import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { format } from 'app/shared/utils/string.util';
import { SybaseCopySource } from 'app/model/pipeline/copysource/sybase.copysource';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const sybaseMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.sybase.linkedServiceType,
    displayName: stringResources.Sybase_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-Sybase'
    },
    supportDatasetV2: true,
    isOnPremises: true,
    isFirstClass: true,
    previewByQuery: true,
    tableColumnNameQuotes: ['"', '"'],
    copySinkTypes: [],
    fetchTableNameFromItemPath: true,
    copySourceTypes: [Metamodel.modelFor(SybaseCopySource).name],
    category: ['Database'],
    controls: [
        {
            type: 'textbox',
            bind: 'server',
            label: stringResources.ModelName_ServerName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'database',
            label: stringResources.ModelName_DatabaseName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'select',
            bind: 'authenticationType',
            label: stringResources.ModelName_AuthenticationType,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            defaultValue: 'Basic',
            isLabelVertical: true,
            options: [
                {
                    label: stringResources.AuthenticationType_Select_Basic_Option,
                    value: 'Basic'
                },
                {
                    label: stringResources.AuthenticationType_Select_Windows_Option,
                    value: 'Windows'
                }
            ]
        },
        {
            type: 'textbox',
            bind: 'userName',
            label: stringResources.ModelName_UserName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'password',
            label: stringResources.ModelName_Password,
            child: {
                type: 'password',
                label: stringResources.ModelName_Password,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Sybase_DisplayText),
                stringResources.ModelName_Password)
        }
    ]
};
